import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import { EndpointBotLinkContainer } from "../../../../../../../models/mongodbSchema/aggregates";
import { BaseApiTemplateService, Core2Config } from "../../../shared";


@Injectable({ providedIn: 'root' })
export class AlgEndpointBotLinkService extends BaseApiTemplateService<EndpointBotLinkContainer> {

  constructor(private http: HttpClient) {
    super();
    this.httpClient = http;
    this.apiUrl =  Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "endpoint-bot-link"
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "endpoint-bot-link"
    this.httpClient = http  
  }

}
